import { useCallback } from 'react';
import { useRemoteConfig, useFeatureFlags } from '@funtech-int/yango-shared';

import { useProfileManager } from '@/shared/hooks/useProfileManager';
import { StreamsWatchingRejectionReason } from '@/scenarios/legacy-player/components/error-boundary-context/error-map/map';
import { useHandleError } from '@/scenarios/legacy-player/components/error-boundary-context/context';

import { featureFlagsScheme } from '../../../lib/featureFlags';
import { TelemetryContentPlace } from '../../Player';
import { getChannelPlayerConfig } from '../utils/get-channel-player-config';
import { StreamHandler } from '../../feature-player/hooks/config/use-stream-handler';
import { getChannelOnlineStreams } from '../utils/get-channel-online-streams';

interface Props {
    telemetryContentPlace: TelemetryContentPlace;
}

export const useChannelPlayerConfigHandler: (props: Props) => StreamHandler = (props) => {
    const remoteConfig = useRemoteConfig();
    const profileManager = useProfileManager();
    const featureFlags = useFeatureFlags(featureFlagsScheme);
    const handleError = useHandleError();

    return useCallback(
        (baseInfo) => {
            if (baseInfo?.__typename === 'TvChannel') {
                if (getChannelOnlineStreams(baseInfo)?.streams?.length === 0) {
                    handleError(StreamsWatchingRejectionReason.EMPTY_OTT_STREAMS);
                }
                return getChannelPlayerConfig(baseInfo, props, {
                    remoteConfig,
                    profileManager,
                    featureFlags,
                });
            }
            return null;
        },
        [featureFlags, handleError, profileManager, props, remoteConfig]
    );
};
